(function() {
    $(document).ready(function() {

        $(window).on('pageshow', function() {
            $('.js24LoadingAction:not(.on-load)').removeClass('is-loading');
        });

        $(document).on('click', '.js24LoadingToggle', function() {
            if (!$(this).find('.js24LoadingAction').length) {
                if (!$(this).find('div').length) {
                    $(this).append('<div class="js24LoadingAction"></div>');
                } else {
                    $(this).find('div').addClass('js24LoadingAction');
                }
            }

            const oElement = $(this).find('.js24LoadingAction');
            oElement.addClass('is-loading');

            setTimeout(function() {
                oElement.removeClass('is-loading');
            }, 4000);
        });
    });
})();
